import Response from '../base/Response';

export default class NetworkFailureResponse extends Response {

}
